import {Snack} from './types';
import {createEntityReduxFactory} from '@di-nxt/resource-container';
import {registerWithStore} from '../../../../store/registerWithStore';

export const snackRedux = createEntityReduxFactory<Snack>('snack', 'id');
registerWithStore(snackRedux);
